module.exports = __webpack_public_path__ + "img/mobile-8.f9b19501.jpg";